import type {
  AudioFileSource,
  MediaSource,
} from '@/features/media-file/domain/models/media-file'

export const isMediaSource = (source: AudioFileSource): source is MediaSource =>
  source.kind === 'media' && 'mediaFile' in source
